export const FLAG_ICONS = {
  flagPL: 'https://cdn.naviparking.com/digital_parking/flags/flagPL.svg',
  flagAE: 'https://cdn.naviparking.com/digital_parking/flags/flagAE.svg',
  flagBH: 'https://cdn.naviparking.com/digital_parking/flags/flagBH.svg',
  europeFlag:
    'https://cdn.naviparking.com/digital_parking/flags/europe-flag.svg',
  menaFlag: 'https://cdn.naviparking.com/digital_parking/flags/mena-flag.svg',
  uaeFlag: 'https://cdn.naviparking.com/digital_parking/flags/uae-flag.svg',
  bahrainFlag:
    'https://cdn.naviparking.com/digital_parking/flags/bahrain-flag.svg',
  saudiArabiaFlag:
    'https://cdn.naviparking.com/digital_parking/flags/saudi-arabia-flag.svg'
} as const

export type FlagIconKey = keyof typeof FLAG_ICONS

export const MARKET_FLAGS = {
  pl: FLAG_ICONS.flagPL,
  ae: FLAG_ICONS.flagAE,
  bh: FLAG_ICONS.flagBH
} as const

export const getFlagByMarket = (market: 'pl' | 'ae' | 'bh'): string => {
  return MARKET_FLAGS[market]
}
